import React, { useState } from "react";
import Input from "components/Form/Input";
import InputPassword from "components/Form/InputPassword";
import Button from "components/Button/Button";
import { Link } from "react-router-dom";
import makeToast from "utils/toast/makeToast";
import actionApi from "services/actionApi";
import { REGISTER_STEP_ENUM } from "./RegisterPage";

const RegisterPageStepOne = ({
  register,
  watch,
  handleSubmit,
  errors,
  setError,
  isDirty,
  isValid,
  setStep,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const disabled =
    isSubmitting || !isDirty || !isValid || Object.keys(errors).length > 0;

  const onSubmitEmail = async () => {
    if (Object.keys(errors).length > 0) {
      makeToast({
        label: "One or more fields have an error. Please check and try again",
        type: "error",
      });
    }

    const email = watch("email");
    const password = watch("password");
    const repassword = watch("repassword");

    if (password !== repassword) {
      setError("repassword", {
        type: "custom",
        message: "Password doesn’t match.",
      });
      return;
    }

    setIsSubmitting(true);
    await actionApi
      .registerEmail({
        email: email,
      })
      .then((response) => {
        setStep(REGISTER_STEP_ENUM.STEP_2);
      })
      .catch((err) => {
        setError("email", {
          type: "custom",
          message: err?.response?.data?.errors?.[0],
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <form className="flex flex-col" onSubmit={handleSubmit(onSubmitEmail)}>
        <Input
          {...register("name", { required: true })}
          className="mb-4"
          placeholder="Full Name"
          errors={errors}
        />
        <Input
          {...register("phone", { required: true })}
          className="mb-4"
          placeholder="Phone Number"
          errors={errors}
        />
        <Input
          {...register("email", { required: true })}
          className="mb-4"
          type="email"
          placeholder="Email"
          errors={errors}
        />
        <InputPassword
          {...register("password", { required: true })}
          className="mb-4"
          placeholder="Password"
          errors={errors}
        />
        <InputPassword
          {...register("repassword", { required: true })}
          className="mb-4"
          placeholder="Re-enter Password"
          errors={errors}
        />
        <Button
          type="submit"
          size="large"
          className="w-full mb-6 h-10"
          rounded
          disabled={disabled}
        >
          Next
        </Button>
      </form>
      <span className="self-center text-wce-neutral-7">
        Already have an account?
      </span>
      <div className="self-center">
        <Link to="/login">
          <Button variant="link" size="large">
            Login now
          </Button>
        </Link>
      </div>
    </>
  );
};

export default RegisterPageStepOne;
